import React from 'react';
import PropType from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

import './ExportButton.scss';

export default function ExportButton(props) {
  const { isExportEnabled, openExportDialog } = props;

  return (
    <ButtonWithIcon
      id="export-button"
      type="borderless"
      size="small"
      linkIconSize="s"
      sprite="Upload"
      layout="vertical"
      onClick={() => {
        openExportDialog();
      }}
      disabled={!isExportEnabled}
      className="result-toolbar-export-button e2e-export">
      Export
    </ButtonWithIcon>
  );
}

ExportButton.defaultProps = {
  openExportDialog: () => {
    Logger.error('openExportDialog something went wrong, value from ng is not a function');
  },
};

ExportButton.propType = {
  openExportDialog: PropType.func,
  isExportEnabled: PropType.bool,
};
